import React from 'react';
import { useNavigate } from 'react-router-dom';
import { IconX } from './Icons';

const FEATURES = [
  { icon: '❤️', text: 'Like and save products you love' },
  { icon: '✨', text: 'Publish your own products' },
  { icon: '🔔', text: 'Get notified when someone follows you' },
];

export default function AuthModal({ onClose }) {
  const navigate = useNavigate();

  const go = (path) => { onClose(); navigate(path); };

  return (
    <>
      {/* Backdrop */}
      <div style={st.overlay} onClick={onClose} />

      {/* Card */}
      <div style={st.card}>

        {/* X button */}
        <button style={st.closeBtn} onClick={onClose} aria-label="Close">
          <IconX size={15} color="#333" />
        </button>

        {/* Top gradient band */}
        <div style={st.topBand}>
          <img src="/og-image.png" alt="Nexsap" style={st.logoImg} />
          <p style={st.brandName}>Nexsap</p>
        </div>

        {/* Body */}
        <div style={st.body}>
          <h2 style={st.title}>Join Nexsap</h2>
          <p style={st.sub}>Discover, like and share products with a community of creators.</p>

          {/* Feature list */}
          <div style={st.featureList}>
            {FEATURES.map((f, i) => (
              <div key={i} style={st.featureRow}>
                <span style={st.featureIcon}>{f.icon}</span>
                <span style={st.featureText}>{f.text}</span>
              </div>
            ))}
          </div>

          {/* Divider */}
          <div style={st.divider} />

          {/* Buttons */}
          <button style={st.btnPrimary} onClick={() => go('/login')}>
            Create a free account
          </button>
          <button style={st.btnSecondary} onClick={() => go('/login')}>
            I already have an account
          </button>

          <p style={st.legal}>
            By continuing you agree to our <span style={st.link}>Terms</span> and <span style={st.link}>Privacy Policy</span>.
          </p>
        </div>

      </div>
    </>
  );
}

const st = {
  overlay: {
    position: 'fixed', inset: 0,
    background: 'rgba(10,10,20,0.55)',
    backdropFilter: 'blur(4px)',
    zIndex: 300,
  },

  card: {
    position: 'fixed',
    top: '50%', left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 'min(90vw, 380px)',
    background: '#fff',
    borderRadius: 24,
    overflow: 'hidden',
    zIndex: 301,
    boxShadow: '0 32px 80px rgba(0,0,0,0.28)',
  },

  // X — absolute in the card, on top of the gradient
  closeBtn: {
    position: 'absolute', top: 12, right: 12,
    width: 32, height: 32, borderRadius: 16,
    background: '#fff',
    border: 'none', cursor: 'pointer',
    display: 'flex', alignItems: 'center', justifyContent: 'center',
    zIndex: 10,
    boxShadow: '0 2px 8px rgba(0,0,0,0.18)',
  },

  // Dark gradient top section
  topBand: {
    background: 'linear-gradient(135deg, #0d0d14 0%, #1a1a2e 60%, #4361ee 100%)',
    padding: '32px 24px 28px',
    display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 10,
  },
  logoImg: {
    width: 70, height: 70, borderRadius: 18,
    objectFit: 'cover',
    border: '2px solid rgba(255,255,255,0.3)',
  },
  brandName: {
    color: '#fff', fontSize: 20, fontWeight: 800, margin: 0, letterSpacing: 0.3,
  },

  // White body
  body: {
    padding: '24px 24px 20px',
    display: 'flex', flexDirection: 'column', gap: 0,
  },
  title: {
    fontSize: 20, fontWeight: 800, color: '#0d0d14',
    margin: '0 0 6px', textAlign: 'center',
  },
  sub: {
    fontSize: 13, color: '#888', textAlign: 'center',
    lineHeight: 1.55, margin: '0 0 18px',
  },

  featureList: {
    display: 'flex', flexDirection: 'column', gap: 10, marginBottom: 20,
  },
  featureRow: {
    display: 'flex', alignItems: 'center', gap: 12,
    background: '#f8f9ff', borderRadius: 12, padding: '10px 14px',
  },
  featureIcon: { fontSize: 18, flexShrink: 0 },
  featureText: { fontSize: 13, color: '#333', fontWeight: 500 },

  divider: {
    height: 1, background: '#f0f0f0', margin: '4px 0 18px',
  },

  btnPrimary: {
    width: '100%', height: 50, marginBottom: 10,
    background: 'linear-gradient(135deg, #4361ee, #6a82fb)',
    color: '#fff', border: 'none', borderRadius: 14,
    fontSize: 15, fontWeight: 700, cursor: 'pointer',
    boxShadow: '0 6px 20px rgba(67,97,238,0.35)',
    letterSpacing: 0.2,
  },
  btnSecondary: {
    width: '100%', height: 50, marginBottom: 16,
    background: '#fff', color: '#4361ee',
    border: '1.5px solid #c5caff', borderRadius: 14,
    fontSize: 15, fontWeight: 600, cursor: 'pointer',
  },

  legal: {
    fontSize: 11, color: '#bbb', textAlign: 'center', lineHeight: 1.5, margin: 0,
  },
  link: { color: '#4361ee', cursor: 'pointer' },
};
